import { Applications } from "@/modules/application/components";
import { PageHeader } from "@/shared/components";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useTranslation } from "react-i18next";

export const ApplicationsPage = () => {
  const { t } = useTranslation();

  return (
    <div className="full-width page-container applications">
      <PageHeader/>
      <div className="full-width flexbox justify-content--center h-fit-content page-body">
        <div>
          <div className="full-width mb-20">
            <Heading className="content-title" size="xsmall" weight="bolder">
              {t("applications.title")}
            </Heading>
          </div>
          <Applications/>
        </div>
      </div>
    </div>
  );
};
